export function toolActivityBasename(
  path: string | undefined,
): string | undefined {
  if (!path) {
    return undefined;
  }
  const segments = path.split(/[/\\]/).filter(Boolean);
  return segments.at(-1) ?? path;
}
